// ABOUTME: API endpoint configuration for the frontend
// ABOUTME: Uses same-origin requests since server serves both API and frontend

const API_BASE_URL = "";

export const API_ENDPOINTS = {
  // Authentication endpoints
  login: `${API_BASE_URL}/auth/login`,
  register: `${API_BASE_URL}/auth/register`,
  profile: `${API_BASE_URL}/auth/profile`,
  verifyToken: `${API_BASE_URL}/auth/verify-token`,
  updateProfile: `${API_BASE_URL}/auth/profile`,
  changePasswordAfterReset: `${API_BASE_URL}/auth/change-password-after-reset`,
  users: `${API_BASE_URL}/auth/users`,
  adminUsers: `${API_BASE_URL}/admin/users`,
  adminChats: `${API_BASE_URL}/admin/chats`,
  adminChatThread: (threadId) =>
    `${API_BASE_URL}/admin/chats/thread/${threadId}`,
  updateAdminStatus: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/admin-status`,
  updateUserUsername: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/username`,
  resetUserPassword: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/reset-password`,
  deleteUser: (userId) => `${API_BASE_URL}/admin/users/${userId}`,
  updateAllowedBots: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/allowed-bots`,
  resetToDomainBots: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/reset-to-domain`,
  resetToDefaultBots: (userId) =>
    `${API_BASE_URL}/admin/users/${userId}/reset-to-default`,
  getUserAccess: (userId) => `${API_BASE_URL}/admin/users/${userId}/access`,
  adminBots: `${API_BASE_URL}/admin/bots`,
  adminBot: (botId) => `${API_BASE_URL}/admin/bots/${botId}`,
  updateBot: (botId) => `${API_BASE_URL}/admin/bots/${botId}`,

  // Domain management endpoints
  adminDomains: `${API_BASE_URL}/admin/rules/domains`,
  createDomain: `${API_BASE_URL}/admin/rules/domains`,
  createDomainWithBots: `${API_BASE_URL}/admin/rules/domains/create-with-bots`,
  updateDomain: (domainId) => `${API_BASE_URL}/admin/rules/domains/${domainId}`,
  deleteDomain: (domainId) => `${API_BASE_URL}/admin/rules/domains/${domainId}`,
  addDomainBots: (domainId) =>
    `${API_BASE_URL}/admin/rules/domains/${domainId}/bots`,
  removeDomainBots: (domainId) =>
    `${API_BASE_URL}/admin/rules/domains/${domainId}/bots`,

  // Username rule management endpoints
  adminUsernameRules: `${API_BASE_URL}/admin/rules/usernames`,
  createUsernameRule: `${API_BASE_URL}/admin/rules/usernames`,
  createUsernameRuleWithBots: `${API_BASE_URL}/admin/rules/usernames/create-with-bots`,
  updateUsernameRule: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}`,
  deleteUsernameRule: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}`,
  getUsernameRuleBots: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}/bots`,
  addUsernameRuleBots: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}/bots`,
  removeUsernameRuleBots: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}/bots`,
  replaceUsernameRuleBots: (ruleId) =>
    `${API_BASE_URL}/admin/rules/usernames/${ruleId}/bots`,

  // Bot and chat endpoints
  bots: `${API_BASE_URL}/bots`,
  bot: (botId) => `${API_BASE_URL}/bots/info/${botId}`,
  chat: `${API_BASE_URL}/chat`,
  chatReask: `${API_BASE_URL}/chat/re-ask`,
  userChatThreads: (botId) =>
    `${API_BASE_URL}/chat/threads${botId ? `?botId=${botId}` : ""}`,
  updateThreadTitle: (threadId) =>
    `${API_BASE_URL}/chat/threads/${threadId}/title`,

  // Chat rating and feedback endpoints
  chatRate: (messageId) => `${API_BASE_URL}/chat/rate/${messageId}`,
  chatFeedback: (messageId) => `${API_BASE_URL}/chat/feedback/${messageId}`,
  adminFeedback: `${API_BASE_URL}/admin/chats/feedback`,

  // Evaluation endpoints
  evals: `${API_BASE_URL}/evals`,
  evalResults: `${API_BASE_URL}/evals/results`,
  eval: (evalId) => `${API_BASE_URL}/evals/${evalId}`,
  updateEval: (evalId) => `${API_BASE_URL}/evals/${evalId}`,
  deleteEval: (evalId) => `${API_BASE_URL}/evals/${evalId}`,
  runEval: (evalId) => `${API_BASE_URL}/evals/${evalId}/run`,
  runAllEvals: `${API_BASE_URL}/evals/run-all`,
  deleteEvalResult: (resultId) => `${API_BASE_URL}/evals/results/${resultId}`,
  evalHistory: (evalId) => `${API_BASE_URL}/evals/${evalId}/history`,
  uploadEvalCsv: `${API_BASE_URL}/evals/upload-csv`,

  // State data endpoints
  data: `${API_BASE_URL}/data`,
  stateData: (state, metric) => `${API_BASE_URL}/data/state/${state}/${metric}`,
  ebtTheftStats: `${API_BASE_URL}/data/ebt-theft-stats`,
  articles: (category) => `${API_BASE_URL}/data/articles/${category}`,

  // LlamaCloud endpoints
  createLlamaCloudIndex: `${API_BASE_URL}/data/create-llamacloud-index`,

  // Image analysis endpoints
  analyzeImage: `${API_BASE_URL}/vision/analyze`,
};

export { API_BASE_URL };
